import React from "react";

interface IconProps {
  color?: string;
  width?: number;
  height?: number;
  onClick?: () => void;
}

const ArrowRightIcon: React.FC<IconProps> = ({
  color = "#000000",
  width = 25,
  height = 25,
  onClick,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        fill={color}
        d="M338.752 104.704a64 64 0 0 0 0 90.496l316.8 316.8-316.8 316.8a64 64 0 0 0 90.496 90.496l362.048-362.048a64 64 0 0 0 0-90.496L429.248 104.704a64 64 0 0 0-90.496 0z"
      />
    </svg>
  );
};

export default ArrowRightIcon;